var map = {
	"./AuthorizationModal": 1445,
	"./AuthorizationModal.js": 1445,
	"./BottomModal": 9555,
	"./BottomModal.js": 9555,
	"./CardProduct": 6174,
	"./CardProduct.js": 6174,
	"./CardProductSlider": 9139,
	"./CardProductSlider.js": 9139,
	"./Cart": 8025,
	"./Cart.js": 8025,
	"./CartContext": 3202,
	"./CartContext.js": 3202,
	"./Catalog": 2537,
	"./Catalog.js": 2537,
	"./Categories": 8355,
	"./Categories.js": 8355,
	"./CreatingUserFizicheskoyeLitso": 4105,
	"./CreatingUserFizicheskoyeLitso.js": 4105,
	"./CreatingUserYuridicheskoyeLitso": 9189,
	"./CreatingUserYuridicheskoyeLitso.js": 9189,
	"./DeliveryBlock": 1914,
	"./DeliveryBlock.js": 1914,
	"./DeliveryOrder": 9407,
	"./DeliveryOrder.js": 9407,
	"./FavoriteContext": 5436,
	"./FavoriteContext.js": 5436,
	"./Favourites": 9447,
	"./Favourites.js": 9447,
	"./FeaturesList": 2988,
	"./FeaturesList.js": 2988,
	"./HistoryOfOrders": 4591,
	"./HistoryOfOrders.js": 4591,
	"./LeafletMap": 4694,
	"./LeafletMap.js": 4694,
	"./Main": 1750,
	"./Main.js": 1750,
	"./Map": 5913,
	"./Map.js": 5913,
	"./ModalDeliveryOrder": 1040,
	"./ModalDeliveryOrder.js": 1040,
	"./OrdersBottomModal": 1948,
	"./OrdersBottomModal.js": 1948,
	"./Promotion": 9490,
	"./Promotion.js": 9490,
	"./Slider": 8950,
	"./Slider.js": 8950,
	"./SliderBottomModal": 2664,
	"./SliderBottomModal.js": 2664,
	"./TopBanner": 5638,
	"./TopBanner.js": 5638,
	"./UserCreationModal": 9840,
	"./UserCreationModal.js": 9840,
	"./store_pictures/DeliveryBlock1.jpg": 8869,
	"./store_pictures/categories/Meat_byy_products.jpg": 9147,
	"./store_pictures/categories/Meat_delicacies.jpg": 5612,
	"./store_pictures/categories/beef.jpg": 9472,
	"./store_pictures/categories/cheese.jpg": 6309,
	"./store_pictures/categories/chicken_and_poultry.jpg": 6053,
	"./store_pictures/categories/meat_snacks.jpg": 4705,
	"./store_pictures/categories/milk.jpg": 851,
	"./store_pictures/categories/mutton.jpg": 5271,
	"./store_pictures/categories/oil.jpg": 7656,
	"./store_pictures/categories/vegetables.jpg": 8350,
	"./store_pictures/promotion1.jpg": 3409,
	"./store_pictures/promotion2.jpg": 3798,
	"./store_pictures/promotion3.jpg": 5411,
	"./store_pictures/topbanner.jpg": 5786,
	"./style/AuthorizationModal.css": 3518,
	"./style/BottomModal.css": 9666,
	"./style/CardProduct.css": 7209,
	"./style/CardProductSlider.css": 9962,
	"./style/Cart.css": 3942,
	"./style/CartPickup.css": 8366,
	"./style/Catalog.css": 5383,
	"./style/Categories.css": 8144,
	"./style/CreatingUserFizicheskoyeLitso.css": 7864,
	"./style/CreatingUserYuridicheskoyeLitso.css": 616,
	"./style/DeliveryBlock.css": 8301,
	"./style/DeliveryOrder.css": 9294,
	"./style/Favourites.css": 496,
	"./style/FeaturesList.css": 3241,
	"./style/HistoryOfOrders.css": 794,
	"./style/LeafletMap.css": 5667,
	"./style/Main.css": 9919,
	"./style/Map.css": 5036,
	"./style/ModalDeliveryOrder.css": 7185,
	"./style/OrdersBottomModal.css": 6767,
	"./style/PlacingAnOrder.css": 7027,
	"./style/Promotion.css": 7773,
	"./style/Slider.css": 4731,
	"./style/SliderBottomModal.css": 3119,
	"./style/TopBanner.css": 7405,
	"./style/UserCreationModal.css": 9107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3449;